import { render, staticRenderFns } from "./addResource.vue?vue&type=template&id=7dac153b&scoped=true&"
import script from "./addResource.vue?vue&type=script&lang=js&"
export * from "./addResource.vue?vue&type=script&lang=js&"
import style0 from "./addResource.vue?vue&type=style&index=0&id=7dac153b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dac153b",
  null
  
)

component.options.__file = "addResource.vue"
export default component.exports